<template>
  <div>
    <div class="row">
      <div class="col custom_input">
        <input
          v-model.lazy="$v.inn.$model"
          type="text"
          name="inn"
          id="inn"
          required
          v-mask="'############'"
        />
        <label for="inn">{{ $t('ИНН') }}</label>
        <span class="clear_icon" @click="inn = ''"></span>
        <div class="error" v-if="!$v.inn.minLength">
          Длина ИНН {{ $v.inn.$params.minLength.min }} цифр.
        </div>
      </div>
      <!-- <div class="col custom_input">
                <input v-model="newContract.address" type="text" name="address" id="address" required />
                <label for="address">{{ $t("Адрес") }}</label>
                <span class="clear_icon" @click="clearInput('address')"></span>
            </div> -->
      <div class="col custom_input">
        <input
          v-model.lazy="$v.checking_account.$model"
          v-mask="'####################'"
          type="text"
          name="checking_account"
          id="checking_account"
          required
        />
        <label for="checking_account">{{ $t('Расчётный счёт') }}</label>
        <span class="clear_icon" @click="checking_account = ''"></span>
        <div class="error" v-if="!$v.checking_account.minLength">
          Длина расчетного счета {{ $v.checking_account.$params.minLength.min }} цифр.
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col custom_input">
        <input
          v-model.lazy="$v.corresponding_account.$model"
          v-mask="'####################'"
          type="text"
          name="corresponding_account"
          id="corresponding_account"
          required
        />
        <label for="corresponding_account">{{ $t('Корр. счёт') }}</label>
        <span class="clear_icon" @click="corresponding_account = ''"></span>
        <div class="error" v-if="!$v.corresponding_account.minLength">
          Длина Корр. счета {{ $v.corresponding_account.$params.minLength.min }} цифр.
        </div>
      </div>
      <div class="col custom_input">
        <input
          v-model.lazy="$v.bik.$model"
          v-mask="'#########'"
          type="text"
          name="bik"
          id="bik"
          required
        />
        <label for="bik">{{ $t('БИК') }}</label>
        <span class="clear_icon" @click="bik = ''"></span>
        <div class="error" v-if="!$v.bik.minLength">
          Длина БИК {{ $v.bik.$params.minLength.min }} цифр.
        </div>
      </div>
    </div>
    <div class="row align-items-end mt-4">
      <div class="col-6 custom_input">
        <input
          v-model.lazy="$v.passport_ogrn.$model"
          v-mask="'#############'"
          type="text"
          name="passport_ogrn"
          id="passport_ogrn"
          required
        />
        <label for="passport_ogrn">{{ $t('ОГРН') }}</label>
        <span class="clear_icon" @click="passport_ogrn = ''"></span>
        <div class="error" v-if="!$v.passport_ogrn.minLength">
          Длина ОГРН {{ $v.passport_ogrn.$params.minLength.min }} цифр.
        </div>
      </div>
      <div class="col custom_input">
        <input v-model.lazy="$v.ip_name.$model" type="text" name="ip_name" id="ip_name" required />
        <label for="ip_name">{{ $t('ФИО ИП') }}</label>
        <span class="clear_icon" @click="ip_name = ''"></span>
      </div>
    </div>
    <!-- НОВЫЕ ПОЛЯ -->
    <div class="row mt-4">
      <div class="col custom_input">
        <input
          v-model.lazy="$v.bank_name.$model"
          type="text"
          name="bank_name"
          id="bank_name"
          required
        />
        <label for="bank_name">{{ $t('Банк') }}</label>
        <span class="clear_icon" @click="bank_name = ''"></span>
      </div>
      <div class="col custom_input">
        <input
          v-model.lazy="$v.address_legal.$model"
          type="text"
          name="address_legal"
          id="address_legal"
          required
        />
        <label for="address_legal">{{ $t('Юр. адрес') }}</label>
        <span class="clear_icon" @click="address_legal = ''"></span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col custom_input">
        <input
          v-model.lazy="$v.address_fact.$model"
          type="text"
          name="address_fact"
          id="address_fact"
          required
        />
        <label for="address_fact">{{ $t('Почтовый адрес') }}</label>
        <span class="clear_icon" @click="address_fact = ''"></span>
      </div>
      <div class="col-6 custom_input">
        <date-picker
          v-model="rangeDate"
          :editable="false"
          placeholder="дата ОГРНИП"
          format="DD.MM.YYYY"
          value-type="YYYY-MM-DD"
          style="width: 100%"
        >
        </date-picker>
      </div>
    </div>
    <div class="row align-items-end mt-4">
      <div class="col-6 offset-6">
        <button
          :class="`btn_type_1 ${canCreate ? 'disabled' : ''}`"
          :disabled="canCreate"
          @click="createDocument"
        >
          Создать договор
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import backAPI from '../assets/backApi';

export default {
  name: 'ContractByIP',
  components: {
    DatePicker,
  },
  data() {
    return {
      inn: '',
      checking_account: '',
      corresponding_account: '',
      bik: '',
      passport_ogrn: '',
      ip_name: '',
      bank_name: '',
      address_legal: '',
      address_fact: '',
      rangeDate: null,
    };
  },
  validations: {
    inn: {
      required,
      minLength: minLength(12),
    },
    checking_account: {
      required,
      minLength: minLength(20),
    },
    corresponding_account: {
      required,
      minLength: minLength(20),
    },
    bik: {
      required,
      minLength: minLength(9),
    },
    passport_ogrn: {
      required,
      minLength: minLength(13),
    },
    ip_name: {
      required,
    },
    bank_name: {
      required,
    },
    address_legal: {
      required,
    },
    address_fact: {
      required,
    },
  },
  methods: {
    clearInput(key) {
      this.newContract[key] = '';
    },
    async createDocument() {
      const params = {
        inn: this.inn,
        checking_account: this.checking_account,
        corresponding_account: this.corresponding_account,
        bik: this.bik,
        passport_ogrn: this.passport_ogrn,
        ip_name: this.ip_name,
        bank_name: this.bank_name,
        address_legal: this.address_legal,
        address_fact: this.address_fact,
        ogrnip_dte: this.rangeDate,
      };
      backAPI.post('/agent/create-contract-ip', params).then(() => {
        this.$emit('created');
      });
    },
  },
  computed: {
    canCreate() {
      return this.rangeDate === null || this.$v.$invalid;
    },
  },
};
</script>
<style scoped>
.dirty {
  border-color: #5a5;
  background: #efe;
}

.dirty:focus {
  outline-color: #8e8;
}

.error {
  color: red;
}

.error:focus {
  outline-color: #f99;
}
</style>
